module.exports = "https://coursera_assets.s3.amazonaws.com/images/f1111f74895b67144dfbf492027ed13d.png";